import VidaaTVLoader from '@/utils/vidaaTVLoader';

class VidaaTVService {
  private static instance: VidaaTVService;
  private loader: VidaaTVLoader;
  private vidaaTV: any = null;

  private constructor() {
    this.loader = new VidaaTVLoader({
      clientId: process.env.VIDAA_CLIENT_ID!,
      environment: process.env.NODE_ENV === 'production' ? 'production' : 'dev',
    });
  }

  static getInstance(): VidaaTVService {
    if (!VidaaTVService.instance) {
      VidaaTVService.instance = new VidaaTVService();
    }
    return VidaaTVService.instance;
  }

  async initialize(): Promise<any> {
    if (this.vidaaTV) {
      return this.vidaaTV;
    }
    console.log('🚀🚀🚀 ########### initialising VIDAA');
    this.vidaaTV = await this.loader.loadLatest();
    return this.vidaaTV;
  }

  getVidaaTV(): any {
    if (!this.vidaaTV) {
      throw new Error('VidaaTV not initialized. Call initialize() first.');
    }
    return this.vidaaTV;
  }

  isInitialized(): boolean {
    return this.vidaaTV !== null;
  }
}

export default VidaaTVService;
